import { render, staticRenderFns } from "./ViMessage.vue?vue&type=template&id=2955ed56"
import script from "./ViMessage.vue?vue&type=script&lang=js"
export * from "./ViMessage.vue?vue&type=script&lang=js"
import style0 from "./ViMessage.vue?vue&type=style&index=0&id=2955ed56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports